/**
 * AAA IDP delivery method reducer
 * 
 */
import { DELETE, DELIVERY_METHOD } from '../../actions/types';
export const initialState = {
  error: false,
  required: true,
  valid: null,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case DELIVERY_METHOD:
      {
        const {
          value
        } = action;
        const valid = value === 'Postage' || value === 'PickUpInStore' ? true : false;
        return {
          ...state,
          error: !valid,
          value,
          valid
        };
      }
    default:
      return state;
  }
}